import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'epc-grid-cell-inbound',
  templateUrl: './grid-cell-inbound.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridCellInboundComponent {
  // reason it to be string that instead of 0 we want to show "-"
  @Input() public displayedQuantity?: string;
}
